import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from 'src/app/core/helpers/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { Loyaltic } from 'src/app/core/helpers/api-url.constants';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'loyaltic-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('rewardsCarousel', { static: false }) rewardsCarousel?: ElementRef<HTMLElement>;
  culture = '';
  isLoggedIn = false;
  userId = '';
  popupKeysObj:any;
  showGenericPopup = false;
  hasGames = true;
  isLoading = true;

  calendarBoosted = false;
  calendarStartDate = '';
  calendarEndDate = '';
  calendarPlayedDates: string[] = [];

  externalUrl = Loyaltic.WithOutReceiptRedirectUrl;
  private fragmentSub?: Subscription;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private coreService: CoreService) {
    this.culture = translate.getDefaultLang();
    this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {
    this.checkDates();
    if (this.isLoggedIn){
      this.userId = this.authService.getUserId()
      this.coreService.login();
      let participateApiResult = JSON.parse(localStorage.getItem('participateApiResult'));
      this.calendarPlayedDates = participateApiResult.slotsInfo
        .filter(slot => slot.isPlayed && slot.slotStatus !== 'COMPLETED') // only slots where isPlayed = false
        .map(slot => {
          const date = new Date(slot.date);
          // Format as yyyy/mm/dd
          const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
          return formattedDate;
        });
      this.coreService.loadResponse$.subscribe((res) => {
        this.getAvailableSlots();
      });
      /*this.coreService.getAvailableGames(this.userId).then((response: any) => {
        // response.result.availableGames = 0;  //remove this line
        if (response.result.availableGames === 0) {
          this.popupKeysObj = {
            headerKey : 'heading-no-games-available',
            bodyKey :  'subheading-no-games-available'
          }
          this.hasGames = false;
          var uploadsectionelement = document.getElementById("participatesection");
          uploadsectionelement.scrollIntoView({ behavior: "smooth" });
        }
      });*/
    }
  }

  ngAfterViewInit(): void {
    this.fragmentSub = this.route.fragment.subscribe(fragment => {
      if (fragment === 'rewards-section') {
        setTimeout(() => this.scrollToRewards(), 0);
      }
    });
  }

  getAvailableSlots() {
    this.coreService.getAvailableSlots(this.userId).then((response:any) => {
      localStorage.setItem('participateApiResult', JSON.stringify(response.result));
      this.calendarPlayedDates = response.result.slotsInfo
        .filter(slot => slot.isPlayed && slot.slotStatus !== 'COMPLETED') // only slots where isPlayed = false
        .map(slot => {
          const date = new Date(slot.date);
          // Format as yyyy/mm/dd
          const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
          return formattedDate;
        });
    })
  }

  ngOnDestroy(): void {
    this.localizationService.currentPage = '';
    this.fragmentSub?.unsubscribe();
  }

  async checkDates() {
    await this.coreService.getLiveConfig().then((response: any) => {
      this.calendarStartDate = response.result.campaignStart;
      this.calendarEndDate = response.result.campaignEnd;
      this.cdr.detectChanges();
      this.isLoading = false;
    }).catch((error) => {
      // Geo-restriction errors will be handled by the interceptor and app.component
      // Just stop loading to prevent UI from hanging
      this.isLoading = false;
      if (error.status !== 403 || error.error?.message !== 'This service is only available from Finland.') {
        console.error('Error fetching live config:', error);
      }
    });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: "smooth" });
  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate(['']);
 }

  onCalendarBoosted(active: boolean) {
    this.calendarBoosted = active;
  }

  scrollToRewards(event?: Event): void {
    event?.preventDefault();
    const target = this.rewardsCarousel?.nativeElement || document.getElementById('rewards-section');
    if (!target) {
      return;
    }

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}
